module.exports = __webpack_public_path__ + "static/media/ro-RO.1a52f234.md";